import { CardContent } from '@mui/material';
import { styled } from '@silverstein-properties/inspirelabs-ui';

export const StyledCardContent = styled(CardContent)(({ theme }) => ({
  padding: theme.spacing(5),
  '&:last-child': {
    paddingBottom: theme.spacing(5),
  },
}));
